module.exports = {
  "slider": {
    "position": "absolute",
    "top": 0
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-53a95640!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-ep-slider/index.vue
// module id = 471
// module chunks = 0 1